import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { HttpCommonService } from '@shared/services/http-common.service';
import { GenericHttpResponse } from '@shared/services/interfaces/generic-http-response.interface';
import {
  EstablecimientosUbicacionFilters,
  EstablecimientosUbicacionPaginatedResponse
} from './establecimientos.interface';

@Injectable({
  providedIn: 'root'
})
export class EstablecimientosUbicacionService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(filters: EstablecimientosUbicacionFilters): Observable<GenericHttpResponse<EstablecimientosUbicacionPaginatedResponse>> {
    const url = this.httpCommonService.makeUrl('/ubic/establecimientos', filters);
    return this.http.get<GenericHttpResponse<EstablecimientosUbicacionPaginatedResponse>>(url);
  }
}
